import React, { FunctionComponent } from 'react';
import { Table } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';
import { buttonStyles } from 'components/Button/Button';
import { theme } from 'config';
import { Offer } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';

import EndOfferModal from './sections/EndOfferModal';

type Props = {
  classes: ClassProp<typeof styles>;
  brands: Offer;
};

const buttonStyle = buttonStyles(theme);

const styles = {
  supplementalRow: {
    border: '0 !important;',
    background: '#fafbfb',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  infoHeader: {
    fontWeight: '500',
    margin: '0 !important',
  },
  infoContainer: {
    width: '50%',
    display: 'inline-block',
    padding: '1.25rem',
    margin: 0,
  },
  couponId: {
    color: '#683caf',
  },
  endOfferButton: {
    ...buttonStyle.button,
    marginLeft: '1rem',
    marginTop: 0,
  },
};

const MoreInfo: FunctionComponent<Props> = ({ brands, classes }) => (
  <React.Fragment key={brands.offerUuid}>
    <Table.Row className={classes.supplementalRow}>
      <Table.Cell className={classes.supplementalRow} colSpan={12}>
        <div className={classes.container}>
          <div className={classes.infoContainer}>
            <p className={classes.infoHeader}>Coupon ID</p>
            <p className={classes.couponId}>{brands.couponId}</p>
          </div>

          <div className={classes.infoContainer}>
            <p className={classes.infoHeader}>Offer Keywords</p>
            <p>{brands.offerKeywords}</p>
          </div>

          <div className={classes.infoContainer}>
            <p className={classes.infoHeader}>Offer UUID</p>
            <p className={classes.couponId}>{brands.offerUuid}</p>
          </div>

          <div className={classes.infoContainer}>
            <p className={classes.infoHeader}>Description</p>
            <p>{brands.offerDescription}</p>
          </div>

          <EndOfferModal
            title="Schedule Offer To End"
            offerUuid={brands.offerUuid}
            trigger={
              <button className={classes.endOfferButton}>
                Schedule Offer To End
              </button>
            }
          />
        </div>
      </Table.Cell>
    </Table.Row>
  </React.Fragment>
);
export default withStyles(styles)(MoreInfo);
